
import { DEVELOPMENT } from "../utils"
import axios, { withRetry } from './axios'


export async function getCities(): Promise<string[]> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return fake_cities
  }

  const res = await axios.get('/cities')
  const cities: string[] = res.data.data.sort()
  cities.unshift('Все')

  return cities
}

var fake_cities = [
  'Все',
  "Москва",
]